import cookie from 'react-cookie';
import * as userApi from '../common/api/user';
import {
  getUserBwWindWaveModel,
} from '../selectors/user';

export const FETCH_USER_DETAILS = 'FETCH_USER_DETAILS';
export const FETCH_USER_DETAILS_SUCCESS = 'FETCH_USER_DETAILS_SUCCESS';
export const FETCH_USER_DETAILS_FAILURE = 'FETCH_USER_DETAILS_FAILURE';

export const FETCH_USER_ENTITLEMENTS = 'FETCH_USER_ENTITLEMENTS';
export const FETCH_USER_ENTITLEMENTS_SUCCESS = 'FETCH_USER_ENTITLEMENTS_SUCCESS';
export const FETCH_USER_ENTITLEMENTS_FAILURE = 'FETCH_USER_ENTITLEMENTS_FAILURE';

export const FETCH_USER_FAVORITES = 'FETCH_USER_FAVORITES';
export const FETCH_USER_FAVORITES_SUCCESS = 'FETCH_USER_FAVORITES_SUCCESS';
export const FETCH_USER_FAVORITES_FAILURE = 'FETCH_USER_FAVORITES_FAILURE';

export const FETCH_PAYMENT_WARNINGS = 'FETCH_PAYMENT_WARNINGS';
export const FETCH_PAYMENT_WARNINGS_SUCCESS = 'FETCH_PAYMENT_WARNINGS_SUCCESS';
export const FETCH_PAYMENT_WARNINGS_FAILURE = 'FETCH_PAYMENT_WARNINGS_FAILURE';

export const FETCH_USER_SETTINGS = 'FETCH_USER_SETTINGS';
export const FETCH_USER_SETTINGS_SUCCESS = 'FETCH_USER_SETTINGS_SUCCESS';
export const FETCH_USER_SETTINGS_FAILURE = 'FETCH_USER_SETTINGS_FAILURE';

export const SET_USER_LOCATION = 'SET_USER_LOCATION';
export const SET_USER_LOCATION_SUCCESS = 'SET_USER_LOCATION_SUCCESS';
export const SET_USER_LOCATION_FAILURE = 'SET_USER_LOCATION_FAILURE';

export const SET_DFP_AD_ATTRIBUTES = 'SET_DFP_AD_ATTRIBUTES';
export const SET_DFP_AD_ATTRIBUTES_SUCCESS = 'SET_DFP_AD_ATTRIBUTES_SUCCESS';
export const SET_DFP_AD_ATTRIBUTES_FAILURE = 'SET_DFP_AD_ATTRIBUTES_FAILURE';

export const SET_USER_BW_WIND_WAVE_MODEL = 'SET_USER_BW_WIND_WAVE_MODEL';
export const SET_USER_BW_WIND_WAVE_MODEL_SUCCESS = 'SET_USER_BW_WIND_WAVE_MODEL_SUCCESS';
export const SET_USER_BW_WIND_WAVE_MODEL_FAILURE = 'SET_USER_BW_WIND_WAVE_MODEL_FAILURE';

export const fetchUserDetails = userDetails => async (dispatch) => {
  dispatch({ type: FETCH_USER_DETAILS });

  try {
    const details = userDetails || await userApi.fetchUserDetails();
    dispatch({
      type: FETCH_USER_DETAILS_SUCCESS,
      details,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_DETAILS_FAILURE,
      error: err,
    });
  }
};

export const fetchUserEntitlements = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_ENTITLEMENTS });

  try {
    const { entitlements, legacyEntitlements } = await userApi.fetchUserEntitlements();
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_SUCCESS,
      entitlements,
      legacyEntitlements,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_ENTITLEMENTS_FAILURE,
      error: err,
    });
  }
};

export const fetchUserFavorites = userDetails => async (dispatch) => {
  dispatch({ type: FETCH_USER_FAVORITES });

  try {
    const { favorites } = await userApi.fetchUserFavorites(userDetails);
    dispatch({
      type: FETCH_USER_FAVORITES_SUCCESS,
      favorites,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_FAVORITES_FAILURE,
      error: err,
    });
  }
};

export const fetchPaymentWarnings = () => async (dispatch) => {
  dispatch({ type: FETCH_PAYMENT_WARNINGS });
  try {
    let warningType;
    const warnings = await userApi.fetchPaymentWarnings();
    const filteredWarnings = warnings && warnings.filter(({ type, planId }) => {
      if ((type === 'invalidZip') || (type === 'failedPayment' && planId.startsWith('bw'))) {
        return true;
      }
      return false;
    });
    const warningTypes = filteredWarnings.map(({ type }) => type);
    if (warningTypes.includes('invalidZip')) warningType = 'invalidzip';
    if (warningTypes.includes('failedPayment')) warningType = 'failedpayment';
    dispatch({
      type: FETCH_PAYMENT_WARNINGS_SUCCESS,
      warningType,
    });
  } catch (err) {
    dispatch({
      type: FETCH_PAYMENT_WARNINGS_FAILURE,
      error: err,
    });
  }
};

export const fetchUserSettings = () => async (dispatch) => {
  dispatch({ type: FETCH_USER_SETTINGS });

  try {
    const settings = await userApi.fetchUserSettings();
    dispatch({
      type: FETCH_USER_SETTINGS_SUCCESS,
      settings,
    });
  } catch (err) {
    dispatch({
      type: FETCH_USER_SETTINGS_FAILURE,
      error: err,
    });
  }
};

export const setUserLocation = location => async (dispatch) => {
  dispatch({ type: SET_USER_LOCATION });

  try {
    dispatch({
      type: SET_USER_LOCATION_SUCCESS,
      location,
    });
  } catch (err) {
    dispatch({
      type: SET_USER_LOCATION_FAILURE,
      error: err,
    });
  }
};

export const setUserBwWindWaveModel = () => async (dispatch, getState) => {
  const state = getState();
  const { user } = state;
  const loggedIn = !!user.details;
  const userBwWindWaveModel = getUserBwWindWaveModel(state);
  const bwWindWaveModel = userBwWindWaveModel === 'LOLA' ? 'NCEP' : 'LOLA';

  dispatch({ type: SET_USER_BW_WIND_WAVE_MODEL });

  try {
    if (loggedIn) {
      // Fire this off asynchronously but do not await.
      userApi.updateUserSettings({
        bwWindWaveModel: [bwWindWaveModel],
      });
    } else {
      cookie.save('bw_wind_wave_model', bwWindWaveModel, {
        path: '/',
        domain: location.hostname,
        maxAge: 31536000, // 1 year
        expires: new Date((new Date()).getTime() + (31536000 * 1000)),
      });
    }
    dispatch({
      type: SET_USER_BW_WIND_WAVE_MODEL_SUCCESS,
      bwWindWaveModel,
    });
  } catch (err) {
    dispatch({
      type: SET_USER_BW_WIND_WAVE_MODEL_FAILURE,
      error: err,
    });
  }
};

export const setDFPAdAttributes = (reqUrl, reqQuery) => async (dispatch) => {
  dispatch({ type: SET_DFP_AD_ATTRIBUTES });
  try {
    const adTargets = [];
    const URLArray = ['BW_URL', reqUrl];
    adTargets.push(URLArray);
    const { qaFlag } = reqQuery;
    if(qaFlag) adTargets.push(['BW_qaFlag', qaFlag])
    let pageType = "Home";
    if (reqUrl.includes('forecast/marine-weather')) {
      pageType = "Forecast";
      adTargets.push(['BW_contentKeyword', 'seakeeperlogodec15']);
    }
    if (reqUrl.includes('map')) {
      pageType = "Map";
    }
    adTargets.push(['BW_pageType', pageType]);
    const adAttributes = {
        adTargets,
      };
    dispatch({
      type: SET_DFP_AD_ATTRIBUTES_SUCCESS,
      adAttributes,
    });
  } catch (err) {
    dispatch({
      type: SET_DFP_AD_ATTRIBUTES_FAILURE,
      error: err,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/user.js